'use client';

import { motion } from 'framer-motion';

export const MotionDiv = motion.div;
